import React, { Component } from 'react';
import { db } from '../../api/firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import 'bootstrap/dist/css/bootstrap.min.css';

class ContactForm extends Component {
    state = {
        name: '',
        phone: '',
        email: '',
        message: '',
        error: {},
        successMessage: '',
        errorMessage: ''
    };

    changeHandler = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            [name]: value,
            error: { ...prevState.error, [name]: '' }
        }));
    };

    submitHandler = async (e) => {
        e.preventDefault();

        const { name, phone, email, message } = this.state;
        let error = {};

        if (!name) error.name = 'Veuillez entrer votre nom';
        if (!message) error.message = 'Veuillez entrer votre message';
        if (!phone) error.phone = 'Veuillez entrer votre numéro de téléphone';

        if (Object.keys(error).length > 0) {
            this.setState({ error });
            return;
        }

        try {
            await addDoc(collection(db, 'messages'), {
                name,
                phone,
                email: email || '', // Optional field
                message,
                date: serverTimestamp(),
                seen: false
            });

            this.setState({
                name: '',
                phone: '',
                email: '',
                message: '',
                error: {},
                successMessage: 'Message envoyé avec succès!',
                errorMessage: ''
            });
        } catch (error) {
            console.error('Erreur lors de l\'envoi du message:', error);
            this.setState({
                successMessage: '',
                errorMessage: 'Une erreur est survenue. Veuillez réessayer.'
            });
        }
    };

    render() {
        const { name, phone, email, message, error, successMessage, errorMessage } = this.state;

        return (
            <form onSubmit={this.submitHandler} className="form">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="mb-3">
                            <input value={name} onChange={this.changeHandler} type="text" name="name" placeholder="Nom" className="form-control" />
                            {error.name && <div className="text-danger">{error.name}</div>}
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="mb-3">
                            <input value={phone} onChange={this.changeHandler} type="tel" name="phone" placeholder="Téléphone" className="form-control" />
                            {error.phone && <div className="text-danger">{error.phone}</div>}
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                        <div className="mb-3">
                            <input value={email} onChange={this.changeHandler} type="email" name="email" placeholder="Email (optionnel)" className="form-control" />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="mb-3">
                            <textarea value={message} onChange={this.changeHandler} name="message" placeholder="Message" className="form-control"></textarea>
                            {error.message && <div className="text-danger">{error.message}</div>}
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-submit">
                            <button type="submit" className="theme-btn">Envoyer le message</button>
                        </div>
                    </div>

                    {/* Success and Error Messages */}
                    {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
                    {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                </div>
            </form>
        );
    }
}

export default ContactForm;
